"use client";

import { NormalText } from "@/components/text/NormalText";
import { WarningResourceCard } from "@/components/warning/WarningResourceCard";
import { User, UserNoDates } from "@/types/types";
import { getNumberOfCustomModelsAllowedClientTemp } from "@/utils/subscriptionLevels/getNumberOfCustomModelsAllowedClientTemp";
import { getSecondsToAdd } from "@/utils/subscriptionLevels/time/getSecondsToAdd";
import { getFormattedTimeLeft } from "@/utils/time/getFormattedTimeLeft";

export function ResourceCards({
  user,
  numberOfModels,
  downgradeStripeSubscriptionId,
  className,
}: {
  user: UserNoDates;
  numberOfModels: number;
  downgradeStripeSubscriptionId: NonNullable<User["stripeSubscriptionId"]>;
  className?: string;
}) {
  // Calculate the number of custom models locked after downgrading
  const numberOfCustomModelSlotsNewPlan =
    getNumberOfCustomModelsAllowedClientTemp(downgradeStripeSubscriptionId);

  const numberOfCustomModelsLocked = Math.max(
    0,
    numberOfModels - numberOfCustomModelSlotsNewPlan
  );

  // Calculate the amount of conversion time lost after downgrading null mean the user has unlimited conversion minutes
  const conversionTimeNewPlanSeconds = getSecondsToAdd(
    downgradeStripeSubscriptionId
  );
  const conversionTimeNowSeconds = user.conversionTimeLeftSeconds;

  const conversionTimeSecondsLost =
    conversionTimeNewPlanSeconds === null || conversionTimeNowSeconds === null ?
      0
    : Math.max(0, conversionTimeNowSeconds - conversionTimeNewPlanSeconds);

  return (
    <div className={className}>
      <WarningResourceCard className="mb-4">
        {conversionTimeSecondsLost === 0 ?
          <div className="flex justify-between gap-x-4">
            <NormalText elementType="p">
              New monthly conversion time:
            </NormalText>

            <NormalText elementType="p">
              {conversionTimeNewPlanSeconds === null ?
                "Unlimited"
              : getFormattedTimeLeft(conversionTimeNewPlanSeconds)}
            </NormalText>
          </div>
        : <div className="flex justify-between gap-x-4">
            <NormalText elementType="p">Conversion time lost:</NormalText>

            <NormalText elementType="p" className="text-red-600">
              {getFormattedTimeLeft(conversionTimeSecondsLost)}
            </NormalText>
          </div>
        }
      </WarningResourceCard>

      <WarningResourceCard className="mb-4">
        {numberOfCustomModelsLocked === 0 ?
          <div className="flex justify-between gap-x-4">
            <NormalText elementType="p">
              New custom voice model slots:
            </NormalText>

            <NormalText elementType="p">
              {numberOfCustomModelSlotsNewPlan}
            </NormalText>
          </div>
        : <div className="flex justify-between gap-x-4">
            <NormalText elementType="p">Custom voice models locked:</NormalText>

            <NormalText elementType="p" className="text-red-600">
              {numberOfCustomModelsLocked}
            </NormalText>
          </div>
        }
      </WarningResourceCard>
    </div>
  );
}
